/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-12-09 19:09:57
 * @LastEditors: mrh
 * @LastEditTime: 2020-07-31 16:59:41
 */
import axios from 'axios'
import store from '@/store'
import { Toast } from 'vant'
axios.create({
    withCredentials: true, // 是否携带cookie
    timeout: 5000 // 请求超时
})

axios.interceptors.request.use(function (config) {
    if (typeof config.data == "string") {
        return config
    }
    if (config.data == '' || config.data == null || config.data == undefined) {
        if (store.getters.token) {
            config.params['token'] = store.getters.token
        }
        return config
    } else {
        if (store.getters.token) {
            config.data['token'] = store.getters.token
        }
        return config
    }
}, function (error) {
    return Promise.reject(error)
})

axios.interceptors.response.use(
    response => {
        let res = {};
        res.status = response.status
        res.data = response.data;
        let list = [0, 5, 6, 7, 4016, 5114, 5244];
        if (!list.includes(res.data.appStatus.errorCode)) {
            Toast({
                duration: 2000, // 持续展示 toast
                forbidClick: true,
                message: res.data.appStatus.message,
            })
        }
        // switch (res.data.appStatus.errorCode) {
        //     case 4016:
        //         logouts()
        //         break;
        //     case 2009:
        //         logouts()
        //         break;
        // }
        return res;
    },
    error => {
        return Promise.reject(error)
    }
)
function logouts() {
    if (store.getters.ambientType == 0) {
        wx.miniProgram.navigateTo({ url: "/pages/login/login" });
    } else if (store.getters.ambientType == 1) {
        window.Android.logout();
    } else if (store.getters.ambientType == 2) {
        window.webkit.messageHandlers.logout.postMessage("");
    }

}

export default axios